/**
 * **이 브라우저의 시간대 이름**. 하루 무료·출석의 "하루" 를 사용자 시간대로 정하려고 서버에 알린다.
 * 서버는 이름이 맞는지 다시 보고(틀리면 Asia/Seoul), 판정은 DB 가 한다 — 화면이 날짜를 정하지 않는다.
 */
export function tzHeader(): Record<string, string> {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    return tz ? { 'x-fatemap-tz': tz } : {}
  } catch {
    return {}
  }
}
